import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-spec-group',
  templateUrl: './add-spec-group.component.html',
  styleUrls: ['./add-spec-group.component.css']
})
export class AddSpecGroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
